export default __webpack_public_path__ + "static/media/editIcon.cfa12cd4.svg";